module.exports = __webpack_public_path__ + "static/media/man-waist.7a4896e6.svg";